import React from 'react';

import { useIntl } from 'react-intl';

import { queryClient } from 'src/lib/react-query';
import { DataTableNewEntryProps } from 'src/registry/components/table/types';
import { generalMessages } from 'src/registry/utils/messages';
import { ICON_MAP } from 'src/utils/constants';
import { toast } from 'src/hooks/useToast';
import { useParams } from 'react-router-dom';
import { ServicePlanBillingPolicy } from 'src/features/servicePlanBillingPolicies/utils/types';
import {
    LIST_SERVICE_PLAN_BILLING_POLICIES_RESOURCE
} from 'src/features/servicePlanBillingPolicies/api/useListServicePlanBillingPolicies';
import {
    useCreateServicePlanBillingPolicy
} from 'src/features/servicePlanBillingPolicies/api/useCreateServicePlanBillingPolicy';
import { billingPoliciesMessages } from 'src/features/servicePlanBillingPolicies/utils/messages';
import ServicePlanBillingPolicyFormModal
    from 'src/features/servicePlanBillingPolicies/components/forms/ServicePlanBillingPolicyFormModal';

interface CreateServicePlanBillingPolicyFormModalProps<TData> extends DataTableNewEntryProps<TData> {
    selectedServicePlanBillingPolicy?: ServicePlanBillingPolicy;
    children?: React.ReactNode;
}

function CreateServicePlanBillingPolicyFormModal<TData>({ className }: CreateServicePlanBillingPolicyFormModalProps<TData>) {
    const { formatMessage } = useIntl();
    const { servicePlanItemId = '' } = useParams();

    const { mutate, isPending } = useCreateServicePlanBillingPolicy({
        onSuccess: () => {
            void queryClient.invalidateQueries({ queryKey: [LIST_SERVICE_PLAN_BILLING_POLICIES_RESOURCE] });
            toast({
                title: formatMessage(billingPoliciesMessages.createServicePlanBillingPolicySuccess),
                description: formatMessage(billingPoliciesMessages.createServicePlanBillingPolicySuccessDescription),
            });
        },
    });

    return (
        <ServicePlanBillingPolicyFormModal
            className={className}
            mutate={(values, onSuccess, onError) => mutate({ ...values, servicePlanItemId }, { onSuccess, onError })}
            title={formatMessage(generalMessages.createEntry, {
                entry: formatMessage(billingPoliciesMessages.billingPolicy).toLowerCase(),
            })}
            icon={ICON_MAP.ADD}
            isPending={isPending}
            subtitle={formatMessage(billingPoliciesMessages.addServicePlanBillingPolicySubtitle)}
        />
    );
}

export default CreateServicePlanBillingPolicyFormModal;
